import {
  recordSlice,
  SET_FOO,
  SET_COMMENT,
} from '@app/src/actions/austriaActions';

const {
  SET_RECORD_LOADING,
  SET_RECORD_ERROR,
  SET_RECORD_REQUEST_ID,
  SET_RECORD_ENTITIES,
} = recordSlice.constants;

export {
  SET_RECORD_LOADING,
  SET_RECORD_ERROR,
  SET_RECORD_REQUEST_ID,
  SET_RECORD_ENTITIES,
  SET_FOO,
  SET_COMMENT,
};
